import { useCallback, useMemo } from "react"
import { useSearchParams } from "react-router-dom"

export const useWelcomeFlow = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const welcomeParam = searchParams.get("welcome")

  const welcomeState = useMemo(() => {
    if (welcomeParam === "invitation") {
      const inviterName = sessionStorage.getItem("welcomeInviterName") || ""
      return { showModal: true, inviterName }
    }
    return { showModal: false, inviterName: "" }
  }, [welcomeParam])

  const clearWelcome = useCallback(() => {
    sessionStorage.removeItem("welcomeInviterName")
    const newParams = new URLSearchParams(searchParams)
    newParams.delete("welcome")
    setSearchParams(newParams, { replace: true })
  }, [searchParams, setSearchParams])

  return { ...welcomeState, clearWelcome }
}
